import script from "./ProductViewer_ysc.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductViewer_ysc.vue?vue&type=script&setup=true&lang=js"

import "./ProductViewer_ysc.vue?vue&type=style&index=0&id=2eddd042&lang=scss&scoped=true"

import exportComponent from "/home/lw8dl1214/actions-runner/_work/AIPR-Frontend/AIPR-Frontend/haleon-ar-detector/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2eddd042"]])

export default __exports__